"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ICON_SIZE_FACTOR = 22;

var DownloadIcon = function DownloadIcon(_ref) {
  var className = _ref.className,
      size = _ref.size;
  return _react.default.createElement("svg", {
    className: className,
    height: ICON_SIZE_FACTOR * size,
    viewBox: "0 0 31.8 46",
    width: ICON_SIZE_FACTOR * size
  }, _react.default.createElement("path", {
    d: "M26.8,23.8l-10.9,11L5,23.8l1.6-1.6l8.2,8.3V5H17v25.5l8.2-8.3L26.8,23.8z M5.8,41v-2.2H26V41H5.8z"
  }));
};

DownloadIcon.defaultProps = {
  className: '',
  size: 1
};
DownloadIcon.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.number
};
var _default = DownloadIcon;
exports.default = _default;